// config
import * as http from 'utils/http';
import config from 'config';

const PAGE_SIZE = '200';

// Could be moved in next iteration to tenant config
const getCarrierUserGroupsUsers = async (args) => {
  //   mock
  //   const data = mock;
  //   await new Promise((resolve) => setTimeout(resolve, 3000));
  // real
  const segmentIds = args[1];
  const segmentQueryParams = segmentIds
    .split(',')
    .map((id) => `carrier_user_groups=${id}`)
    .join('&');
  const data = await http.get(
    `${config.BASE_ROUTE}v1/users/?${segmentQueryParams}&page_size=${PAGE_SIZE}`
  );
  return data;
};

export default getCarrierUserGroupsUsers;
